import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@travelwin/core';
import { useUser } from '../context/User';
import { NavItem } from '../interfaces/NavBar';

export const useMyAccountItem = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const myAccount: NavItem = useMemo(
    () => ({
      id: '2',
      label: user
        ? t('navbar.my_account', 'My Account')
        : t('navbar.login', 'Log In'),
      to: '/my-account',
      ecommerceRoute: true,
      visible: true,
      'data-testid': 'link-account',
      icon: <Icon size={24} name="myAccount" />,
    }),
    [user],
  );

  return myAccount;
};
